import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import { Link } from "react-router-dom";
import { API_GET, API_POST } from "../../services/api.service";
import _ from "underscore";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import UserDropdown from "../common/UserDropdown";


import { Chart } from "react-google-charts";
import GenerateField from "../common/GenerateField";
import Box from "../Dashboard/Box";
import InfoBox from "../../components/InfoIcon/InfoIcon";
import { getConfigurationByName, getTeamDetails } from "../common/helper";






function CallTracker(props) {
  const { user, startDate, endDate, isReload , configSettings} = props;
  const [data, setData] = useState([]);
  const [rawData, setRawData] = useState([]);
  const [reportData, setreportData] = useState([]);
  const [trackerData, setTrackerData] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedCallType, setSelectedCallType] = useState('business');
  const [dynamicHeight, setDynamicHeight] = useState(100);
  const [dynamicHeightTracker, setDynamicHeightTracker] = useState(100);
  const [hidePersonalCallDetail, sethidePersonalCallDetail] = useState(false);
  const [total, setTotal] = useState({});
  const [callerData, setCallerData] = useState([]);

  

  let totalCallRecording = {
    endDate: {
      $gte: new Date(startDate),
      $lt: new Date(endDate),
    }
  }


  Date.prototype.addHours = function(h) {
    this.setTime(this.getTime() + (h*60*60*1000));
    return this;
  }

  const loadWorkloadData = async () => {
    setData([]);
    setRawData([]);
    setreportData([]);
    setTrackerData([])
    let query;
    

    const  hidePersonalCall = await getConfigurationByName(user,"hidePersonalCallDetail");

    sethidePersonalCallDetail(hidePersonalCall)
  
    query = {
      startDate: {
        $gte: new Date(startDate).setHours(0, 0, 0, 0),
        $lt: new Date(endDate).setHours(23, 59, 59, 0),
      },
      admin: user && user.admin
    };
    //debugger;
    if (user && ["field_exc", "agent"].indexOf(user.role) > -1) {
      query = { ...query, caller: user && user.username };
    }

    let body = {
      limit: 0,
      skip: 0,
      sort: { startDate: 1 },
    };
    let res = await API_POST("action/getPaginationDataActivity", {
      root: "CallDetails",
      querydata: query,
      body

    });

    // let res = await API_GET("action/AggregateReport", null, {
    //   admin: user && user.admin
    // });
    //debugger;

    if (res.data && res.data.activityData.length > 0) {

      let data = res.data.activityData;
      //debugger;

      setRawData(data || []);

    }

    let trackerquery = {};
    let dateObj = window.moment(new Date());
    trackerquery =  {date:dateObj.format('YYYY-MM-DD'),admin: user && user.admin };

    if(user.role != 'owner' ){
      trackerquery.user = user.username;
    }

    let trackerres = await API_POST("action/getdata", {
      root: "timeTraker",
      con: trackerquery,
    });

    if (trackerres.data && trackerres.data.length > 0) {


      console.log("tracking data",trackerres.data)

     let ttempdata = [
        [
          { type: "string", id: "Position" },
          { type: "string", id: "Name" },
          { type: "date", id: "Start" },
          { type: "date", id: "End" },
        ]
      ];

      let action = [];
      trackerres.data.map( (d)=>{
d.history.sort((a, b) => new Date(a.actionOn) - new Date(b.actionOn));

        d.history.map((p,k)=>{
          let nextAction = window.moment(p.actionOn);
          let currentAction =  window.moment(p.actionOn);

          if(d.history[k+1] && d.history[k+1].actionOn){
            nextAction = window.moment(d.history[k+1].actionOn);
           
          }else{
            nextAction = window.moment();
          }
          // console.log("action",p.lastAction,nextAction)
if(currentAction.isBefore(nextAction)){
          ttempdata.push([d.user,p.status,currentAction,nextAction]);
//action.push(nextAction)
          }
        })
      })


      //console.log("tttttttttttt",ttempdata)

      if(trackerres.data.length){
        setDynamicHeightTracker(100 * trackerres.data.length);
        setTrackerData(ttempdata);
      }

    }
    //setChartOption(_chartOption);
  };


  useEffect(() => {
    if (user && user.admin) {
      loadWorkloadData();
    }
  }, [user, isReload , selectedUsers]);

  useEffect(() => {
    CreateReport();
  }, [rawData, selectedUsers, selectedCallType,trackerData]);


  const CreateReport = () => {
    let data = rawData;
    let reportData = [];
    let graphData = [];

    // Initialize total with default values
    const initialTotal = {
      totalCalls: 0,
      ConnectedCalls: 0,
      OutgoingCalls: 0,
      IncomingCalls: 0,
      MissedCalls: 0,
      Talktime: 0
    };

    setTotal(initialTotal);

    if (!data || data.length === 0) {
      setreportData([]);
      return [];
    }

    // Filter data based on call type
    if (selectedCallType === 'business') {
      data = data.filter(row => row.pid !== undefined);
    }

    // Filter data based on selected users
    let filteredData = data;
    if (selectedUsers.length > 0) {
      filteredData = data.filter(row => selectedUsers.includes(row.caller));
    }

    // Prepare graph data header
    graphData.push([
      { type: "string", id: "Caller" },
      { type: "string", id: "Phone" },
      { type: 'string', role: 'style' },
      { type: "date", id: "Start" },
      { type: "date", id: "End" }
    ]);

    // Process data for graph and ensure numeric values
    const processedData = filteredData.map(v => ({
      ...v,
      caller: getTeamDetails(v.caller) && getTeamDetails(v.caller).first_name || v.caller,
      duration: parseInt(v.duration) || 0,
      talktime: parseInt(v.talktime) || 0
    }));

    // Build graph data
    processedData.forEach(element => {
      if (element.caller) {
        const obj = [
          element.caller,
          element.phone,
          element.pid ? '#4285f4' : '#db4437',
          new Date(element.startDate),
          new Date(element.endDate)
        ];
        graphData.push(obj);
      }
    });

    setData(graphData);

    // Calculate dynamic height
    const heightData = _.groupBy(processedData, num => num.caller);
    const height = 50 + (80 * Object.keys(heightData).length);
    setDynamicHeight(height);

    // Initialize total tracking object
    let totalJson = { ...initialTotal };

    // Process hourly data
    for (let hour = 0; hour < 24; hour++) {
      // Filter data for current hour - use processedData which has parsed numeric values
      const hourlyData = processedData.filter(row => 
        new Date(row.startDate).getHours() === hour
      );

      if (hourlyData.length === 0) continue;

      // Calculate metrics for this hour
      const hourMetrics = {
        hour: `Time - ${hour}${hour >= 12 ? ' pm' : ' am'}`,
        totalCalls: hourlyData.length,
        ConnectedCalls: hourlyData.filter(row => row.duration > 0).length,
        OutgoingCalls: hourlyData.filter(row => 
          ['OUTGOING', 'Outgoing', 'default'].includes(row.type)
        ).length,
        IncomingCalls: hourlyData.filter(row => 
          ['INCOMING', 'Incoming'].includes(row.type)
        ).length,
        MissedCalls: hourlyData.filter(row => 
          ['MISSED', 'Missed', 'REJECTED'].includes(row.type)
        ).length,
        Talktime: hourlyData.reduce((sum, row) => {
          // Use talktime field if available, otherwise fall back to duration
          const talkTime = row.talktime || row.duration || 0;
          return sum + talkTime;
        }, 0)
      };

      // Only add to report if there's actual data
      if (hourMetrics.totalCalls > 0) {
        reportData.push(hourMetrics);
      }

      // Accumulate totals
      totalJson.totalCalls += hourMetrics.totalCalls;
      totalJson.ConnectedCalls += hourMetrics.ConnectedCalls;
      totalJson.OutgoingCalls += hourMetrics.OutgoingCalls;
      totalJson.IncomingCalls += hourMetrics.IncomingCalls;
      totalJson.MissedCalls += hourMetrics.MissedCalls;
      totalJson.Talktime += hourMetrics.Talktime;
    }

    // Debug: Log the raw talktime value before formatting
    console.log("Raw total talktime before formatting:", totalJson.Talktime);
    
    // Debug: Calculate sum of individual hour talktimes for verification
    const sumOfHourlyTalktimes = reportData.reduce((sum, hour) => sum + hour.Talktime, 0);
    console.log("Sum of individual hour talktimes:", sumOfHourlyTalktimes);
    console.log("Calculated total talktime:", totalJson.Talktime);
    console.log("Difference:", Math.abs(sumOfHourlyTalktimes - totalJson.Talktime));

    // Format talktime using the same method as individual hours
    try {
      totalJson.Talktime = fancyTimeFormat(totalJson.Talktime || 0);
    } catch (e) {
      console.error("Error formatting talktime:", e);
      totalJson.Talktime = "0:00";
    }

    // Update state
    setTotal(totalJson);
    setreportData(reportData);

    // Process caller-wise data
    const callerMetrics = [];
    const callerGroups = _.groupBy(processedData, row => row.caller);
    
    Object.keys(callerGroups).forEach(callerName => {
      const callerCalls = callerGroups[callerName];
      
      const callerMetric = {
        caller: callerName,
        totalCalls: callerCalls.length,
        ConnectedCalls: callerCalls.filter(row => row.duration > 0).length,
        OutgoingCalls: callerCalls.filter(row => 
          ['OUTGOING', 'Outgoing', 'default'].includes(row.type)
        ).length,
        IncomingCalls: callerCalls.filter(row => 
          ['INCOMING', 'Incoming'].includes(row.type)
        ).length,
        MissedCalls: callerCalls.filter(row => 
          ['MISSED', 'Missed', 'REJECTED'].includes(row.type)
        ).length,
        Talktime: callerCalls.reduce((sum, row) => {
          const talkTime = row.talktime || row.duration || 0;
          return sum + talkTime;
        }, 0)
      };
      
      callerMetrics.push(callerMetric);
    });
    
    // Sort caller data by total calls (descending)
    callerMetrics.sort((a, b) => b.totalCalls - a.totalCalls);
    setCallerData(callerMetrics);

    return reportData;
  };

  const handleChangeUserDDL = (users) => {
    console.log("handleChangeUserDDL", users);
    setSelectedUsers(users);
    //CreateReport(data, users)
  }
  const onChangeCallType = (e) => {
    console.log("onChangeCallType", e.target.value);
    setSelectedCallType(e.target.value);
    //CreateReport(data, users)
  }

  const fancyTimeFormat=(duration)=>
  {
    // Hours, minutes and seconds
    var hrs = ~~(duration / 3600);
    var mins = ~~((duration % 3600) / 60);
    var secs = ~~duration % 60;

    // Output like "1:01" or "4:03:59" or "123:03:59"
    var ret = "";

    if (hrs > 0) {
      ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
    }

    ret += "" + mins + ":" + (secs < 10 ? "0" : "");
    ret += "" + secs;
    return ret;
  }


  const columnsTracker = [
    {
      name: "User",
      cell: (row) => (
        <span>{row.username}</span>
      ),
    },
    {
      name: "Login Time",
      cell: (row) => (
        <span>
          {row.firstLoginTime && window.moment(row.firstLoginTime).add(6.5,'hours').format('YYYY-MM-DD hh:mm:ss')  }
        </span>
      ),
    },
    {
      name: "Hour worked",
      cell: (row) => (
        <span>
          {fancyTimeFormat(row.loginTime)  }
        </span>
      ),
    },
    {
      name: "Break Time",
      cell: (row) => (
        <span>
          {fancyTimeFormat(row.breakTime)  }
        </span>
      ),
    },
    {
      name: "Logout Time",  
      cell: (row) => (
        <span>
          {row.lastLogout && window.moment(row.lastLogout).add(6.5,'hours').format('YYYY-MM-DD hh:mm:ss')  }
        </span>
      ),
    },
  ]

  const columns = [
    {
      name: "Hour",
      cell: (row) => (
        <span>
          {row.hour}
        </span>
      )
    },
    {
      name: "Total Calls",
      cell: (row) => (
        <span>
          {row.totalCalls}
        </span>
      )
      
    },
    {
      name: "Connected Calls",
      cell: (row) => (
        <span>
          {row.ConnectedCalls}
        </span>
      )
      
     
    },
    {
      name: "Outgoing Calls",
      
      cell: (row) => (
        <span>
          {row.OutgoingCalls}
        </span>
      )
    },
    {
      name: "Incoming Calls",
      
      cell: (row) => (
        <span>
          {row.IncomingCalls}
        </span>
      )
    },
    {
      name: "Missed Calls",
      
      cell: (row) => (
        <span>
          {row.MissedCalls}
        </span>
      )
    },
    {
      name: "Talktime",
      
      cell: (row) => (
        <span>
          {fancyTimeFormat(row.Talktime)  }
        </span>
      ),
    },
  ]

  const callerColumns = [
    {
      name: "Caller",
      cell: (row) => (
        <span>
          {row.caller}
        </span>
      )
    },
    {
      name: "Total Calls",
      cell: (row) => (
        <span>
          {row.totalCalls}
        </span>
      )
    },
    {
      name: "Connected Calls",
      cell: (row) => (
        <span>
          {row.ConnectedCalls}
        </span>
      )
    },
    {
      name: "Outgoing Calls",
      cell: (row) => (
        <span>
          {row.OutgoingCalls}
        </span>
      )
    },
    {
      name: "Incoming Calls",
      cell: (row) => (
        <span>
          {row.IncomingCalls}
        </span>
      )
    },
    {
      name: "Missed Calls",
      cell: (row) => (
        <span>
          {row.MissedCalls}
        </span>
      )
    },
    {
      name: "Talktime",
      cell: (row) => (
        <span>
          {fancyTimeFormat(row.Talktime)}
        </span>
      ),
    },
  ]

  if (user && ["field_exc", "agent"].indexOf(user.role) > -1) {
    totalCallRecording['user'] = user && user.username;
  }




  return (

    <>
    
      <GridContainer>
        <GridItem xs={12} sm={4} md={4}>
          <h3>
            Call Tracking Report
          </h3>
          <GridItem  style={{float: "right", marginTop:"-40px"}}>
            <InfoBox name={'Dashboard.CallDetailWise'}/>
          </GridItem>

        </GridItem>
        {
          user && user.role !="agent" &&  <GridItem xs={12} sm={4} md={4}>
            <UserDropdown user={user} id="users" label="My Team" handleChange={handleChangeUserDDL} ></UserDropdown>
          </GridItem>

        }
      

{
          user && (user.role !="agent" || (user.role =="agent" && !hidePersonalCallDetail)) &&
        <GridItem xs={12} sm={4} md={4}>
          <GenerateField

            onChange={onChangeCallType}
            value={selectedCallType}
            id={'CallType'}
            name={'CallType'}
            label={'CallType'}
            type="select"
            keyValuePair={[{ key: 'all', value: 'ALL' }, { key: 'business', value: 'Business' }]}
          />

        </GridItem>
}

      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={4} md={2}>

          <Box
            label={"Total Calls"}
            icon={"fa fa-compress fa-4x"}
            color="success"
            propData={total.totalCalls}
            user={user}
            small={true}
            isReload={isReload}
          />

        </GridItem>
        <GridItem xs={12} sm={4} md={2}>

          <Box
            label={"Total Incoming"}
            icon={"fa fa-arrow-down fa-4x"}
            color="primary"
            propData={total.IncomingCalls}
            user={user}
            small={true}
            isReload={isReload}
          />

        </GridItem>
        <GridItem xs={12} sm={4} md={2}>

          <Box
            label={"Total Outgoing"}
            icon={"fa fa-arrow-up fa-4x"}
            color="success"
            propData={total.OutgoingCalls}
            user={user}
            small={true}
            isReload={isReload}
          />

        </GridItem>
        <GridItem xs={12} sm={4} md={2}>

          <Box
            label={"Total Missed"}
            icon={"fa fa-retweet fa-4x"}

            color="danger"
            propData={total.MissedCalls}
            user={user}
            small={true}
            isReload={isReload}
          />

        </GridItem>
        <GridItem xs={12} sm={4} md={2}>

          <Box
            label={"Total TalkTime"}
            icon={"fa fa-volume-control-phone fa-4x"}
            color="success"
            propData={total.Talktime}
            user={user}
            small={true}
            isReload={isReload}
          />

        </GridItem>
        <GridItem xs={12} sm={4} md={2}>
          <Box
            label={"Total Recordings"}
            icon={"fa fa-microphone fa-4x"}
            root="CallRecording"
            color="success"
            query={totalCallRecording}
            user={user}
            small={true}
            isReload={isReload}
          />


        </GridItem>
      </GridContainer>
      <GridContainer>


{ 

      configSettings && configSettings.enableTimeTracking &&       <GridItem xs={12} sm={12} md={12}>
          <Card chart>
            <CardHeader color="primary">
            { trackerData && trackerData.length > 0 &&
               <Chart
                  chartType="Timeline"
                  data={trackerData}
                  width="100%"
                  height={dynamicHeightTracker}
                  options={{
                    timeline: { colorByRowLabel: false,groupByRowLabel:true },
                    allowHtml: true,
avoidOverlappingGridLines: false,
                    hAxis: {
                      format: 'HH:MM'
                    },
          
                    height:dynamicHeightTracker,                   
                  }}
                />
             }
            </CardHeader>
            <CardBody>
              <i>
                Agent Working Time tracking report
              </i>

            </CardBody>
          </Card>



        </GridItem>

     }



        <GridItem xs={12} sm={12} md={12}>
          <Card chart>
            <CardHeader color="primary">
              <DataTable
                columns={columns}
                data={reportData || []}
                highlightOnHover
                dense
              />
            </CardHeader>
            <CardBody>
              <i>
                Agent call tracking Hourly report
              </i>

            </CardBody>
            <CardFooter chart />
          </Card>



        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <Card chart>
            <CardHeader color="primary">
              <DataTable
                columns={callerColumns}
                data={callerData || []}
                highlightOnHover
                dense
              />
            </CardHeader>
            <CardBody>
              <i>
                Agent call tracking Caller-wise report
              </i>

            </CardBody>
            <CardFooter chart />
          </Card>



        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <Card chart>
            <CardHeader color="primary">
              {data && data.length > 0 &&

                <Chart
                  chartType="Timeline"
                  data={data}
                  width="100%"
                  height={dynamicHeight}
                  options={{
                    is3D: true,
                    timeline: {
                      colorByRowLabel: true,
                    },
                  }}
                />
              }
            </CardHeader>
            <CardBody>
              {data.length == 0 && <i>No Agent activity data yet.</i>}
            </CardBody>
            <CardFooter chart />
          </Card>

        </GridItem>

      </GridContainer>
    </>
  );
}

export default CallTracker;


